import { usePartialAuth } from '~/contexts/AuthContext'

import { basicLogger, LDProvider, useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect } from 'react'
import { APP_ENV, LAUNCH_DARKLY_ID } from '~/lib/config'

export type LaunchDarklyFlagSet = {
  releaseLineConnect: boolean
  release3DSecure: boolean
  releaseExpenseFeature: boolean

  // やりとり、来店予定、応募一覧の上部コンポーネント
  // キャンペーン情報と、タブ機能
  releaseNewCampaignUiSharedComponents: boolean

  releaseNewCampaignEntriesUi: boolean
  releaseCampaigns: boolean
  releaseMobileCampaignList: boolean
  releaseNewScheduleUi: boolean

  // オファー一覧とオファー詳細
  releaseMobileOfferDetail: boolean
}
export type LaunchDarklyFlagKey = keyof LaunchDarklyFlagSet

export const LaunchdarklyProvider = (props: { children: React.ReactNode }) => {
  const { currentAdv, currentUserAdv } = usePartialAuth()
  const context =
    currentAdv?.companyName && currentUserAdv
      ? {
          kind: 'multi',
          advAccount: {
            key: String(currentAdv.id),
            name: currentAdv.companyName,
          },
          userAdv: {
            key: currentUserAdv.id,
            name: currentUserAdv.name,
          },
        }
      : undefined

  return (
    <LDProvider
      clientSideID={LAUNCH_DARKLY_ID}
      context={context}
      options={{
        logger:
          APP_ENV === 'local' || APP_ENV === 'development' || APP_ENV === 'development2'
            ? basicLogger({ level: 'info' })
            : basicLogger({ level: 'none' }),
        bootstrap: 'localStorage',
      }}
    >
      <Syncer />
      {props.children}
    </LDProvider>
  )
}

const Syncer = () => {
  const ldClient = useLDClient()
  const { currentAdv, currentUserAdv } = usePartialAuth()

  useEffect(() => {
    if (ldClient && currentAdv?.companyName && currentUserAdv) {
      ldClient.identify({
        kind: 'multi',
        advAccount: {
          key: String(currentAdv.id),
          name: currentAdv.companyName,
        },
        userAdv: {
          key: currentUserAdv.id,
          name: currentUserAdv.name,
        },
      })
    }
  }, [ldClient, currentAdv, currentUserAdv])

  return null
}
